var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('conversation',{attrs:{"collapsable":false,"isPage":"true","statusoid":_vm.statusoid}})}
var staticRenderFns = []
export { render, staticRenderFns }